// frontend/src/components/AnalysisNavigation/AnalysisNavigation.js
// Purpose: Guide user through analysis workflow
// Desired outcome: Provide visual indication of workflow progress and steps with clickable navigation when appropriate


import React from 'react';
import { useDispatch } from 'react-redux';
import { setStep } from '../../state/analysis/analysisSlice';
import './AnalysisNavigation.css';

const AnalysisNavigation = ({ currentStep }) => {
  const dispatch = useDispatch();
  
  // Define workflow steps with labels
  const steps = [
    { id: 'fileSelection', label: 'File Selection' },
    { id: 'columnMapping', label: 'Column Mapping' },
    { id: 'partMatching', label: 'Part Matching' },
    { id: 'partContext', label: 'Part Context' },
    { id: 'calculations', label: 'Calculations' },
    { id: 'valueSavingsAnalysis', label: 'Analysis' },
    { id: 'reportGeneration', label: 'Report Generation' }
  ];

  // Find the index of the current step
  const currentStepIndex = steps.findIndex(step => step.id === currentStep);
  
  // Handle step navigation click
  const handleStepClick = (stepId) => {
    // Only allow navigation to previous steps
    const clickedStepIndex = steps.findIndex(step => step.id === stepId);
    if (clickedStepIndex < currentStepIndex) {
      dispatch(setStep(stepId));
    }
  };

  return (
    <div className="analysis-navigation">
      <div className="steps-container">
        {steps.map((step, index) => {
          // Determine step status: current, completed, or upcoming
          let stepStatus = 'upcoming';
          if (index === currentStepIndex) {
            stepStatus = 'current';
          } else if (index < currentStepIndex) {
            stepStatus = 'completed';
          }
          
          return (
            <div className="step-wrapper" key={step.id}>
              <div 
                className={`step ${stepStatus}`}
                onClick={() => stepStatus === 'completed' && handleStepClick(step.id)}
              >
                <div className="step-indicator">
                  {stepStatus === 'completed' ? (
                    <span className="check-icon">✓</span>
                  ) : (
                    <span className="step-number">{index + 1}</span>
                  )}
                </div>
                <div className="step-label">{step.label}</div>
              </div>
              {index < steps.length - 1 && <div className="step-line"></div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnalysisNavigation;